import { toast } from 'sonner';

import { useAxios } from '@/hooks/useAxios';
import { queryClient } from '@/queryclient';
import { useMutation } from '@/utils/api';

interface ToggleParams {
  plugin: string; // pius_* ID
  enabled: boolean;
}

interface EnabledStatus {
  plugin: string;
  enabled: boolean;
}

export function useTogglePluginEnabled() {
  const axios = useAxios({ doNotImpersonate: true });

  return useMutation<EnabledStatus, Error, ToggleParams>({
    defaultErrorMessage: 'Failed to update plugin state',
    mutationFn: async ({ plugin, enabled }) => {
      const { data } = await axios.put(`/enrichment/${plugin}/enabled`, {
        enabled,
      });
      return data;
    },
    onSuccess: (data, variables) => {
      toast.success(
        `${variables.plugin} ${data.enabled ? 'enabled' : 'disabled'}`
      );
      queryClient.invalidateQueries({
        queryKey: ['enrichment', 'enabled'],
      });
    },
  });
}
